import React from 'react';
import { useSurvey } from '../hooks/useSurvey';
import { ConsentForm } from '../components/survey/ConsentForm';
import { QuestionBlock } from '../components/survey/QuestionBlock';
import { ResultsReport } from '../components/survey/ResultsReport';
import { ProgressBar } from '../components/survey/ProgressBar';
import { Button } from '../components/ui/Button';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';
export function SurveyPage() {
  const {
    hasConsented,
    currentBlock,
    currentBlockIndex,
    totalSteps,
    answers,
    isFinished,
    isSubmitting,
    submitError,
    result,
    canProceed,
    handleConsent,
    handleAnswer,
    nextBlock,
    prevBlock,
    resetSurvey
  } = useSurvey();
  // 1. Show Results
  if (isFinished && result) {
    return <div className="min-h-screen bg-slate-100 py-12 px-4 sm:px-6" data-id="element-91">
        <ResultsReport result={result} onReset={resetSurvey} isSubmitting={isSubmitting} submitError={submitError} data-id="element-92" />
      </div>;
  }
  // 2. Show Consent Form
  if (!hasConsented) {
    return <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4" data-id="element-93">
        <ConsentForm onAccept={handleConsent} data-id="element-94" />
      </div>;
  }
  // 3. Show Survey Blocks
  return <div className="min-h-screen bg-slate-100 py-8 px-4 sm:px-6 lg:px-8" data-id="element-95">
      <div className="max-w-2xl mx-auto space-y-8" data-id="element-96">
        {/* Header with Progress */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-97">
          <div className="flex justify-between items-center mb-4" data-id="element-98">
            <h1 className="text-lg font-bold text-blue-900" data-id="element-99">
              Diagnóstico de PI
            </h1>
            <span className="text-sm font-medium text-slate-500" data-id="element-100">
              Etapa {currentBlockIndex + 1} de {totalSteps}
            </span>
          </div>
          <ProgressBar currentStep={currentBlockIndex} totalSteps={totalSteps} data-id="element-101" />
        </div>

        {/* Current Question Block */}
        <QuestionBlock block={currentBlock} answers={answers} onAnswer={handleAnswer} data-id="element-102" />

        {/* Navigation Buttons */}
        <div className="flex justify-between pt-4" data-id="element-103">
          <Button variant="ghost" onClick={prevBlock} disabled={currentBlockIndex === 0} className={currentBlockIndex === 0 ? 'invisible' : ''} data-id="element-104">
            <ArrowLeft className="mr-2 h-4 w-4" data-id="element-105" />
            Voltar
          </Button>

          <Button variant={canProceed ? 'primary' : 'secondary'} onClick={nextBlock} disabled={!canProceed} className="w-32" data-id="element-106">
            {currentBlockIndex === totalSteps - 1 ? <>
                Finalizar
                <Check className="ml-2 h-4 w-4" data-id="element-107" />
              </> : <>
                Próximo
                <ArrowRight className="ml-2 h-4 w-4" data-id="element-108" />
              </>}
          </Button>
        </div>
      </div>
    </div>;
}